<template>
  <div class="check-item">
    <div class="item-head">
      <div class="item-head-left">
        <van-image :src="headImage" :width="transPxToRem(48)" :height="transPxToRem(48)" round />
        <div class="item-head-content">
          <div class="name-box">
            <span class="name">{{ name }}</span>
            <span>（ID：{{ userId }}）</span>
          </div>
          <div class="mobile-box">
            {{ mobile }}
          </div>
        </div>
      </div>
      <van-icon name="arrow" :color="blackColor9" />
    </div>
    <div class="van-hairline--bottom"></div>
    <van-cell-group :border="false" class="check-content">
      <van-cell
        :border="false"
        :title-style="{ color: blackColor9 }"
        value-class="check-content-value"
        :title="item.label"
        :value="item.value"
        v-for="(item, index) in content"
        :key="index"
      />
    </van-cell-group>
  </div>
</template>
<script setup>
import { transPxToRem } from '@/utils'
import { Image as VanImage } from 'vant'
import { defineProps, toRefs, computed } from 'vue'
import { useCssVar } from '@vueuse/core'
const blackColor9 = useCssVar('--van-black-9', document.documentElement)
const props = defineProps({
  headImage: String,
  name: String,
  userId: [Number, String],
  mobile: String,
  time: String,
  situation: String
})
const { time, situation } = toRefs(props)
const content = computed(() => [
  {
    label: '考核开始',
    value: time.value
  },
  {
    label: '实际情况',
    value: situation.value
  },
])
</script>
<style lang="less" scoped>
.check-item {
  padding: 12px;
  background-color: #fff;
  border-radius: 4px;
  .item-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    .item-head-left {
      display: flex;
      align-items: center;
      .item-head-content {
        margin-left: 12px;
        .name-box {
          display: flex;
          .name {
            font-weight: bold;
          }
        }
        .mobile-box {
          color: var(--van-black-9);
        }
      }
    }
  }
  .check-content {
    // margin-top: 15px;
    // padding-top: 15px;
    .van-cell {
      padding: 7px 0 0 0;
      justify-content: space-between;
      :deep(.van-cell__value) {
        flex: 4;
        color: #222;
      }
    }
  }
}
</style>
